module.exports = __webpack_public_path__ + "static/tokio-logo-6c864c6c8e963ba0af987217aa361a8c.png";